export default {
      id: "248_cm_=_100_+_45_+_100-usage",
      viewBox: "0 0 1000 1000",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#248_cm_=_100_+_45_+_100",
      toString: function () {
        return this.url;
      }
    }